import Divider from "@vfuk/core-divider";
import React from "react";

import styled from "styled-components";

const HeightContainer = styled.div`
  display: flex;
  height: 28px;
  width: 28px;
  justify-content: center;
`;

const VerticalDivider = () => (
  <HeightContainer>
    <Divider appearance="secondary" orientation="vertical" />
  </HeightContainer>
);

export default VerticalDivider;
